<template>
  <MyModal
    v-bind="$attrs"
    v-on="$listeners"
    @on-visible-change="onVisibleChange"
  >
    <!-- <div
      v-for="(name) in Object.keys($slots)"
      :name="name"
    >
      {{ name }}
    </div> -->
    <template
      v-for="(name) in Object.keys($slots)"
      #[name]
    >
      <slot :name="name"></slot>
    </template>
  </MyModal>
</template>

<script>
import { Modal } from 'view-design';
import {
  inIframe,
  parentModalMaskShow,
  parentModalMaskHide,
} from '@/common/createMicroApp/utils';

export default {
  // name: 'FormItemInput',
  components: { MyModal: Modal },
  props: {

  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {},
  // watch: {
  //   '$route.path': {
  //     handler() {
  //       if (inIframe) {

  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  created() {

  },
  mounted() {},
  beforeDestroy() {
    // 组件销毁时 如果没有关闭弹框 通知父应用关闭全局蒙层
    if (inIframe && this.isVisible) {
      parentModalMaskHide();
    }
  },
  methods: {
    onVisibleChange(isVisible) {
      if (inIframe) {
        // 嵌入别的项目全屏蒙层
        if (isVisible) {
          this.isVisible = isVisible;
          parentModalMaskShow();
        }
        if (!isVisible) {
          parentModalMaskHide();
        }
      }

      if (this.$listeners['on-visible-change']) {
        this.$emit(this.$listeners['on-visible-change'], isVisible);
      }
    },
  },
};
</script>
<style lang='less' scoped>
</style>
